var _path, _circle, _circle2, _circle3, _circle4, _circle5, _circle6, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgKcare(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 25,
    viewBox: "0 0 25 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.5005 2.16461C11.1348 0.772624 9.3472 6.46793e-05 7.49187 0C6.50986 0.0011333 5.53775 0.217516 4.63148 0.636696C3.72521 1.05588 2.90267 1.66958 2.2112 2.44248C-0.738109 5.72552 -0.736856 10.8606 2.2137 14.1297L11.4038 24.3164C11.6169 24.7319 12.028 25 12.5005 25C12.6946 24.9979 12.8855 24.9454 13.0579 24.8467C13.2303 24.748 13.3794 24.6059 13.4933 24.4318L22.7874 14.1297C25.738 10.8592 25.738 5.72552 22.7849 2.43692C22.0938 1.66544 21.2719 1.05299 20.3665 0.634772C19.4611 0.216558 18.4901 0.000833064 17.5092 0C15.6539 0.000336166 13.8664 0.772859 12.5005 2.16461ZM21.0125 4.40147C22.9716 6.58414 22.9729 9.99361 21.0151 12.1652L12.5005 21.603L3.98604 12.1652C2.0282 9.99361 2.02945 6.58414 3.98354 4.40702C4.93614 3.35667 6.18204 2.7787 7.49187 2.7787C8.8017 2.7787 10.0426 3.35667 10.9877 4.40425L11.6144 5.09892C11.7307 5.22806 11.8688 5.3305 12.0209 5.4004C12.1729 5.4703 12.3359 5.50628 12.5005 5.50628C12.6652 5.50628 12.8282 5.4703 12.9802 5.4004C13.1323 5.3305 13.2704 5.22806 13.3867 5.09892L14.0134 4.40425C15.9086 2.30771 19.1199 2.31327 21.0125 4.40147Z",
    fill: "url(#paint0_linear_5503_11447)"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 12.8389,
    cy: 8.085,
    r: 1.085,
    fill: "url(#paint1_linear_5503_11447)"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 10.085,
    cy: 9.46391,
    r: 1.085,
    fill: "url(#paint2_linear_5503_11447)"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 11.462,
    cy: 12.2139,
    r: 1.085,
    fill: "url(#paint3_linear_5503_11447)"
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    cx: 12.8389,
    cy: 14.9678,
    r: 1.085,
    fill: "url(#paint4_linear_5503_11447)"
  })), _circle5 || (_circle5 = /*#__PURE__*/React.createElement("circle", {
    cx: 15.5909,
    cy: 9.46391,
    r: 1.085,
    fill: "url(#paint5_linear_5503_11447)"
  })), _circle6 || (_circle6 = /*#__PURE__*/React.createElement("circle", {
    cx: 14.2139,
    cy: 12.2139,
    r: 1.085,
    fill: "url(#paint6_linear_5503_11447)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_5503_11447",
    x1: 12,
    y1: -7,
    x2: 13,
    y2: 38.5,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#54AAE4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2EEDD2"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_5503_11447",
    x1: 12.7662,
    y1: 6.83935,
    x2: 12.7662,
    y2: 9.05184,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#54AAE4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2EEDD2"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_5503_11447",
    x1: 10.0123,
    y1: 8.21826,
    x2: 10.0123,
    y2: 10.4307,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#54AAE4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2EEDD2"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_5503_11447",
    x1: 11.3893,
    y1: 10.9683,
    x2: 11.3893,
    y2: 13.1807,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#54AAE4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2EEDD2"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_5503_11447",
    x1: 12.7662,
    y1: 13.7222,
    x2: 12.7662,
    y2: 15.9347,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#54AAE4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2EEDD2"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_5503_11447",
    x1: 15.5182,
    y1: 8.21826,
    x2: 15.5182,
    y2: 10.4307,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#54AAE4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2EEDD2"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_5503_11447",
    x1: 14.1412,
    y1: 10.9683,
    x2: 14.1412,
    y2: 13.1807,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#54AAE4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2EEDD2"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgKcare);
export default __webpack_public_path__ + "static/media/Kcare.a82b77cafbb41ee1216aadedc8485c92.svg";
export { ForwardRef as ReactComponent };